import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { DestinationAtom, LeadFormAtom } from "_states";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";

const SearchBox = () => {
  const navigate = useNavigate();
  const setLeadFormOpen = useSetRecoilState(LeadFormAtom);
  const [selectedDestination, setSelectedDestination] = useState<string>();
  const [query, setQuery] = useState("");
  const destinations = useRecoilValue(DestinationAtom);

  const filteredDestination =
    query === ""
      ? []
      : destinations
          .filter((destination) =>
            destination.slug.includes(query.toLowerCase())
          )
          .sort()
          .slice(0, 8);

  const searchTour = () => {
    if (selectedDestination) {
      navigate(`/tours/${selectedDestination}`);
    }
  };

  return (
    <section className="mx-auto lg:px-0 px-2">
      <div className="flex md:flex-row flex-col gap-6">
        <Combobox
          value={selectedDestination}
          onChange={(destination) =>
            setSelectedDestination(destination as string)
          }
          onClose={() => setQuery("")}
        >
          <ComboboxInput
            className="md:w-[600px] w-[300px] h-12 p-6 bg-slate-100 border-2 border-primary text-black rounded-full text-xl focus-visible:outline focus-visible:outline-1 focus-visible:outline-primary"
            aria-label="Assignee"
            displayValue={(destination: string) => destination}
            placeholder="Search for destinations"
            onChange={(event) => setQuery(event.target.value)}
          />
          <ComboboxOptions
            anchor="bottom"
            className="md:w-1/3 w-1/2 border border-gray-100 bg-white rounded-lg m-1 empty:invisible"
          >
            {filteredDestination.map((destination) => (
              <ComboboxOption
                key={destination.name}
                value={destination.slug}
                className="data-[focus]:bg-blue-100 px-6 py-2"
              >
                {destination.name}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        </Combobox>
      </div>
    </section>
  );
};

export default SearchBox;
